var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wt-close',{staticClass:"wt2-sg",nativeOn:{"click":function($event){return _vm.onClick.apply(null, arguments)}}})}]

export { render, staticRenderFns }